module.exports = __webpack_public_path__ + "img/dialog-carLicense.8bcfa277.png";